import { storeProductsToFp } from "@/shared/appInit";
import { TStore } from "@/shared/types";

export function quizInitCallFp(storeConfig: TStore) {
    if (!storeConfig.id) {
        return
    }
    const { nonAlcoholStore } = storeConfig
    const { id, cocktailList } = nonAlcoholStore || { id: '', cocktailList: [] }
    if (id && cocktailList?.length > 0) {
        storeProductsToFp(storeConfig, true)
    }
}